import React, { useEffect } from 'react';
import { Box, CloseButton, Flex, Icon, classNames } from './ui';

interface ToastProps {
    message: string;
    type: 'success' | 'error' | 'info';
    onClose: () => void;
    duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const bgClasses = {
        success: 'bg-success',
        error: 'bg-danger',
        info: 'bg-info',
    };

    const iconClasses = {
        success: 'bi-check-circle-fill',
        error: 'bi-exclamation-triangle-fill',
        info: 'bi-info-circle-fill',
    };

    return (
        <Box
            className={classNames(
                'toast show align-items-center text-white border-0',
                bgClasses[type],
            )}
            marginBottom={2}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ zIndex: 1060, maxWidth: '100%' }}
        >
            <Flex>
                <Flex className="toast-body" align="center">
                    <Icon name={iconClasses[type].replace('bi-', '')} marginEnd={2} />
                    {message}
                </Flex>
                <CloseButton
                    white
                    margin="auto"
                    marginEnd={2}
                    onClick={onClose}
                />
            </Flex>
        </Box>
    );
};

export default Toast;
